import { Route } from "vue-router";
import { BOOKING_PORTAL_FLOW } from "@white-label-configuration/constants";
import { isGtd3437AddBookingPortalFlowPrefixPahEnabled } from '@white-label-plugin/launch-darkly';
import { isBookingPortal } from '@white-label-helper/is-booking-portal'
import { useRoute } from '@nuxt/bridge/dist/runtime/composables';

/**
 * Checks the current route's auth0flow matches with the given routeName for the booking-portal wl flow.
 * @param route Vue Routerroute
 * @param routeName (Optional) route name to check auth0 flow against, defaults to BOOKING_PORTAL_FLOW.AUTH0_FLOW
 * @returns True or false if current route matches against name
 */
export const isBookingPortalFlow = (route: Route = useRoute(), routeName: string = BOOKING_PORTAL_FLOW.AUTH0_FLOW): boolean => {
  if (isGtd3437AddBookingPortalFlowPrefixPahEnabled()) {
    return (Array.isArray(route?.meta)
      ? route.meta[0]
      : route?.meta)?.auth0Flow === routeName
  }
  return isBookingPortal;
};
